import styled from "styled-components/macro";
import { COLORES } from "../../constants";

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${COLORES.DEFAULT_MODULE_BACKGROUND};
  margin-bottom: 2rem;
  border-radius: 0.25rem;
`;

export const Header = styled.div`
  width: 100%;
  height: 2rem;
  color: ${COLORES.DEFAULT_MODULE_HEADER_FONT};
  background-color: ${COLORES.DEFAULT_MODULE_HEADER_BACKGROUND};
  font-weight: bold;
  border-radius: 0.25rem 0.25rem 0 0;

  p {
    line-height: 2rem;
    padding-left: 1rem;
  }
`;

export const Content = styled.div`
  padding: 1rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
`;

// DNE2E-131 (rediseño): stepper "Progreso de Hitos" (ocupa las 3 columnas del grid)
export const Stepper = styled.div`
  grid-column: 1 / -1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.75rem 1rem 1.25rem;
`;

export const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  flex: 1;
  position: relative;

  &:not(:last-child)::after {
    content: "";
    position: absolute;
    top: 1rem;
    left: 50%;
    width: 100%;
    height: 2px;
    background-color: #d0d0d0;
    z-index: 0;
  }

  &.done:not(:last-child)::after {
    background-color: #28a745;
  }
`;

export const StepCircle = styled.div`
  position: relative;
  z-index: 1;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.85rem;
  color: #fff;
  background-color: #c9c9c9;

  &.done {
    background-color: #28a745;
  }
  &.active {
    background-color: #d81b60;
  }
`;

export const StepLabel = styled.span`
  font-size: 0.7rem;
  text-align: center;
  color: #555;
`;

export const SectionTitle = styled.div`
  font-weight: bold;
  border-bottom: 2px solid ${COLORES.DEFAULT_MODULE_HEADER_BACKGROUND};
  padding-bottom: 0.25rem;
  margin-bottom: 0.75rem;
  margin-top: 1rem;
  font-size: 0.8rem;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.columns || "1fr 1fr"};
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  align-items: end;
`;

export const SideBySide = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 0.75rem;
`;

export const SectionBox = styled.div`
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  padding: 0.75rem;
  /* DNE2E-131 (rediseño): hitos a todo el ancho, apilados como el mockup */
  grid-column: ${(props) => props.span || "1 / -1"};

  /* Franja lateral de color según estado (resalte del hito) */
  border-left: 4px solid #d0d0d0;

  &.disabled-section {
    opacity: 0.5;
    pointer-events: none;
    background-color: #f5f5f5;
  }

  /* Completado: tarjeta azul claro (como el mockup); el verde queda solo en el badge */
  &.completed-section {
    border-color: #b3d7f0;
    border-left: 4px solid #2196f3;
    background-color: #eaf4fb;
  }

  /* Activo (hito en curso): tarjeta rosa (como el mockup) */
  &.active-section {
    border-left: 4px solid #d81b60;
    background-color: #fdf0f5;
  }

  &.subsanacion-section {
    border-color: #d81b60;
    border-left: 4px solid #d81b60;
    background-color: #fff0f5;
  }

  /* "No aplica": colapsado tipo acordeón (solo la cabecera visible) */
  &.empty-section {
    opacity: 0.7;
    pointer-events: none;
    background-color: #f9f9f9;
    border-style: dashed;
    border-left: 4px solid #d0d0d0;
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
  }

  /* Colapsado: oculta el cuerpo pero deja visible la cabecera y el mensaje "No aplica" */
  &.empty-section > *:not(:first-child):not(.empty-msg) {
    display: none;
  }

  &.empty-section > *:first-child {
    margin-bottom: 0.25rem;
  }

  .empty-msg {
    font-size: 0.75rem;
    font-style: italic;
    color: #777;
    margin: 0.15rem 0 0;
  }
`;

export const SectionBoxHeader = styled.div`
  font-weight: bold;
  border-bottom: 1px solid ${COLORES.DEFAULT_MODULE_HEADER_BACKGROUND};
  padding-bottom: 0.25rem;
  margin-bottom: 0.5rem;
  font-size: 0.8rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HitoStatusBadge = styled.span`
  font-size: 0.65rem;
  font-weight: bold;
  padding: 0.1rem 0.45rem;
  border-radius: 0.75rem;
  white-space: nowrap;

  &.active {
    background-color: #007bff;
    color: white;
  }

  &.completed {
    background-color: #28a745;
    color: white;
  }

  &.pending {
    background-color: #6c757d;
    color: white;
  }

  &.subsanacion {
    background-color: #d81b60;
    color: white;
  }

  &.noaplica {
    background-color: #adb5bd;
    color: white;
  }

  &.bloqueado {
    background-color: #495057;
    color: white;
  }
`;

export const HitoTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0.5rem;

  thead {
    tr {
      height: 1.5rem;
      font-weight: bold;
    }
    th {
      text-align: left;
      padding: 0.25rem 0.5rem;
      font-size: 0.7rem;
    }
  }

  tbody {
    tr {
      height: 2rem;
    }
    td {
      padding: 0.25rem 0.5rem;
      vertical-align: middle;

      input[type="date"],
      input[type="datetime-local"] {
        width: 100%;
        box-sizing: border-box;
        border: thin solid #858585;
        border-radius: 0.1rem;
        padding: 0.15rem 0.25rem;
      }

      input[type="checkbox"] {
        height: 1rem;
        width: 1rem;
      }
    }
  }
`;

export const HitoButtons = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  align-items: center;

  .completed-badge {
    color: #28a745;
    font-weight: bold;
    font-size: 0.85rem;
  }
`;

export const CompletadoIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  font-size: 1.25rem;
  font-weight: bold;
  user-select: none;
  pointer-events: none;
  color: #858585;
`;

export const CompletadoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;

  span:first-child {
    font-weight: bold;
    font-size: 0.75rem;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 0.5rem;
  width: 28rem;
  max-width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  animation: BounceIn 0.15s linear forwards;
  @keyframes BounceIn {
    0% { transform: scale(0); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
  }
`;

export const ModalHeader = styled.div`
  font-weight: bold;
  color: white;
  background-color: ${COLORES.DEFAULT_MODULE_HEADER_BACKGROUND};
  padding: 0 1rem;
  border-radius: 0.5rem 0.5rem 0 0;
  height: 2.25rem;
  line-height: 2.25rem;
  font-size: 0.85rem;
`;

export const ModalBody = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  p {
    text-align: center;
    font-size: 0.85rem;
    margin: 0;
  }
`;

export const ModalButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 0.5rem;
`;

export const ModeIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: 0.25rem;
  background-color: ${(props) => props.variant === "modificar" ? "#cce5ff" : "#fff3cd"};
  border: 1px solid ${(props) => props.variant === "modificar" ? "#004085" : "#856404"};
  font-size: 0.8rem;
  font-weight: bold;
  margin-bottom: 0.75rem;
  color: ${(props) => props.variant === "modificar" ? "#004085" : "#856404"};
`;

export const FieldGroup = styled.div`
  p {
    height: 0.85rem;
    font-weight: bold;
    margin-bottom: 0.15rem;
  }

  .value {
    font-weight: normal;
    height: auto;
  }
`;
